import { routes } from "routes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hideAllMenus } from "store/application/application-action";

import "./styles/Tag.scss";

interface ITagProps {
  title: string;
  isLast?: boolean;
  setSearchInput: (arg: string) => void;
  setCurrentTag: (arg: string[]) => void;
}

export const Tag = ({ title, isLast, setSearchInput, setCurrentTag }: ITagProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClickSearchItem = () => {
    setSearchInput("");
    // @ts-ignore
    setCurrentTag(prev => {
      if (prev.includes(title)) {
        navigate(routes.multipleTag(prev));
        return prev;
      }

      if (prev.length >= 3) {
        return prev;
      }

      navigate(routes.multipleTag([...prev, title]));
      return [...prev, title];
    });
    document?.getElementById("global-search-input")?.blur();
    dispatch(hideAllMenus());
  };

  const handleClickLastTag = () => {
    navigate(routes.trendingTags());
    setSearchInput("");
    setCurrentTag([]);
    dispatch(hideAllMenus());
  };

  const goTo = isLast ? handleClickLastTag : handleClickSearchItem;

  return (
    <li className="Tag" onClick={goTo}>
      <button>{title}</button>
    </li>
  );
};
